module.exports = __webpack_public_path__ + "static/media/sygnet.dba7f081.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/sygnet.svg
// module id = 386
// module chunks = 14